export const getItem = (key: string) => {
    try {
        return window.sessionStorage.getItem(key);
    } catch (err) {
        console.error(err);
        return null;
    }
};

export const setItem = (key: string, value: string) => {
    try {
        return window.sessionStorage.setItem(key, value);
    } catch (err) {
        console.error(err);
    }
};

export const removeItem = (key: string) => {
    try {
        return window.sessionStorage.removeItem(key);
    } catch (err) {
        console.error(err);
    }
};

export const clear = () => {
    try {
        return window.sessionStorage.clear();
    } catch (err) {
        console.error(err);
    }
};
